<template>
  <div>
    <FormGridPanel :tableColumns="columns" @cellClick="cellClick" ref="FormGridPanel"></FormGridPanel>
    <!-- 新增 -->
    <CustomerOrgNeWindow
      ref="resourceWindowRef"
      :title="resourceWindowTitle"
      @onSubModifyResource="onSubModifyResource"
      @onCance="onCloseResourceWindow"
    ></CustomerOrgNeWindow>
  </div>
</template> 

<script>
import ToolBar from "components/btn/listBtn.vue";
import Panel from "components/container/Panel.vue";
import CustomerOrgService from "./service/CustomerOrgManPage.service.js";
import CustomerOrgNeWindow from "./ui/CustomerOrgNeWindow.vue";
import FormGridPanel from "components/grid/CustomerOrgGridPanel.vue";

export default {
  components: { ToolBar, Panel, CustomerOrgNeWindow, FormGridPanel },
  data() {
    return {
      columns: [
        { type: "radio", title: "选择", width: 60, fixed: "left" },
        { type: "seq", width: 60, title: "序号", fixed: "left" },
        {
          field: "customerLevel",
          title: "客户等级",
          editRender: { name: "input" }
        },
        {
          field: "saleOrgCode",
          title: "销售组织编码",
          editRender: { name: "input" }
        },
        {
          field: "saleOrgDesc",
          title: "销售组织描述",
          editRender: { name: "input" }
        },
        // 单元格渲染，自动读取字典配置
        {
          field: "customeGroup",
          title: "客户组织",
          editRender: { name: "input" }
        },
        {
          field: "saleArea",
          title: "销售区域",
          editRender: { name: "input" }
        },
        {
          field: "priceGroup",
          title: "价格组(客户)",
          editRender: { name: "input" }
        },
        {
          field: "saleGroupDesc",
          title: "销售组描述",
          editRender: { name: "input" }
        },
        {
          field: "saleDepartment",
          title: "销售部门",
          editRender: { name: "input" }
        }
      ],
      fromData: {},
      resourceWindowTitle: ""
    };
  },
  created() {},
  updated: function() {},
  methods: {
    ...CustomerOrgService,
    /**
     * 新增平台资源
     */
    onAddPlatResource() {
      let vm = this,
        resourceWindow = vm.$refs.resourceWindowRef,
        resourceForm = resourceWindow.resourceForm || {};
      vm.resourceWindowTitle = "客户组织-新增";
      //显示窗体
      vm.showResourceWindow = true;
      resourceWindow.showWindow(vm.showResourceWindow);
    },
    /**
     * 编辑平台资源
     */
    onEditPlatResource() {
      let vm = this,
        resourceWindow = vm.$refs.resourceWindowRef,
        resourceForm = resourceWindow.resourceForm || {};
      vm.resourceWindowTitle = "客户组织-编辑";
      //显示窗体
      vm.showResourceWindow = true;
      resourceWindow.showWindow(vm.showResourceWindow);
    },
    /**
     * 新增或是修改资源
     */
    onSubModifyResource(resourceData) {
      console.log(resourceData);
      let vm = this,
        resourceWindow = vm.$refs.resourceWindowRef;
      //提交数据
      vm.addPlatResource(resourceData, function(result) {
        if (result.type == "S") {
          vm.isShowWindow = false;
          resourceWindow.resetForm();
          resourceWindow.showWindow(vm.isShowWindow);
          vm.$message.success(result.msg);
        } else {
          console.log(result);
        }
      });
    },
    /**
     * 关闭资源修改或新增窗口
     */
    onCloseResourceWindow(show) {
      let vm = this;
      vm.isShowWindow = show;
    },
    cellClick(data) {}
  }
};
</script>
